import { useState, useEffect, useRef } from 'react'
import { Rnd } from 'react-rnd'

const VideoOffIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
)

function LocalVideo({ localStream, isVideoOff, containerRef }) {
  const videoRef = useRef(null)
  const isPortrait = window.matchMedia('(orientation: portrait)').matches
  const [size, setSize] = useState(
    isPortrait ? { width: 135, height: 180 } : { width: 240, height: 180 }
  )
  const [pos, setPos] = useState(null)

  useEffect(() => {
    if (videoRef.current && localStream) {
      videoRef.current.srcObject = localStream
    }
  }, [localStream])

  useEffect(() => {
    if (containerRef.current && !pos) {
      const rect = containerRef.current.getBoundingClientRect()
      setPos({
        x: rect.width - size.width - 20,
        y: rect.height - size.height - 120
      })
    }
  }, [pos, size, containerRef])

  if (!pos) return null

  return (
    <Rnd
      className="video-container local"
      size={size}
      position={pos}
      onDragStop={(e, d) => setPos({ x: d.x, y: d.y })}
      onResizeStop={(e, direction, ref, delta, position) => {
        setSize({
          width: parseInt(ref.style.width, 10),
          height: parseInt(ref.style.height, 10)
        })
        setPos(position)
      }}
      minWidth={120}
      minHeight={90}
      maxWidth={400}
      maxHeight={300}
      bounds="parent"
      lockAspectRatio={isPortrait ? 3 / 4 : 4 / 3}
    >
      {!localStream && <div className="video-placeholder"><div className="loader loader-sm" /></div>}
      <video ref={videoRef} autoPlay playsInline muted />
      {isVideoOff && <div className="video-off-overlay"><VideoOffIcon /></div>}
    </Rnd>
  )
}

export default LocalVideo
